import React, { useEffect, useState } from "react";
import TopTitleBanner from "../component/TopTitleBanner";
import "../css/dashboard.css";
import "../css/client.css";
import { Box, Modal, Button } from "@mui/material";
import AddClient from "../component/forms/AddClient";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { useAuth } from "../contexts/AuthContext";
import { roles } from "../firebase.collection";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import CheatsheetChartMobile from "../component/clientsList/CheatsheetChartMobile";

export default function CheatsheetContentMobile() {
  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";
  const [userRole, setUserRole] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    height: 600,
    borderRadius: 0,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const [openAddClient, setOpenAddClient] = useState(false);

  const handleCloseAddClient = () => setOpenAddClient(false);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;
          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const isSuperAdmin =
    userRole === "Super Admin" ||
    userRole === "Admin" ||
    userRole === "Support Staff";

  const handleExitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      /* Chrome, Safari & Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE/Edge */
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
  };

  return (
    <div className="right-container-mobile" style={{ zIndex: 1 }}>
      {isSuperAdmin ? (
        <>
          <Modal
            open={openAddClient}
            onClose={handleCloseAddClient}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={styleModalGeneral}>
              <AddClient closemodal={handleCloseAddClient} />
            </Box>
          </Modal>
          <TopTitleBannerMobile title={"Room booking"} />
          <div className="top-component-list-clients"> </div>

          <div
            id="cheatsheet-chart-fullscreen"
            style={{
              position: isFullscreen ? "fixed" : "relative",
              top: isFullscreen ? 0 : "auto",
              left: isFullscreen ? 0 : "auto",
              width: isFullscreen ? "100%" : "auto",
              height: isFullscreen ? "100%" : "auto",
              backgroundColor: isFullscreen ? "white" : "transparent",
              zIndex: isFullscreen ? 9999 : "auto",
              padding: isFullscreen ? "20px" : "0",
            }}
          >
            <CheatsheetChartMobile />
            {isFullscreen && (
              <Button
                variant="contained"
                color="secondary"
                onClick={handleExitFullscreen}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                }}
              >
                Exit Fullscreen
              </Button>
            )}
          </div>
        </>
      ) : (
        <div>
          <TopTitleBanner title={"Advanced search"} />
          <p style={{ marginLeft: "60px", color: "red", fontWeight: "bold " }}>
            --You don't have Super-admin or Admin credentials to access this
            page--
          </p>
        </div>
      )}
    </div>
  );
}
